import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Storage } from '@ionic/storage';
import 'rxjs/add/operator/map';
import { Platform } from 'ionic-angular';
import { Events } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';

// ---- COMMON MODULES ---- //
import { TranslateService } from '@ngx-translate/core';
import { SmartAudio } from '../providers/smart-audio';
import { ConnectivityService } from './connectivity-service';

/*
  Generated class for the Functions provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class Functions {
  difficulty: string;
  language: string;
  gamemode: string;
  gamemodeVersusActive:boolean;
  idGameVersusChosenDev:number; // only for development
  level: number;
  numBg:number;
  showSidemenuButton:boolean=false;
  currentTextblock:any;
  currentDevice:any;
  serverurl: string;
  generatedGuidForThisSession:string;

  debugStringWords: string;

  idCurrentBook:number;
  textblockForSingleSplicingForDB=[];

  walkthrough_text;
  walkthrough_catMood:string="happy";
  scaleForBigScreen:number=1;
  currentBrowser:string='Unknown';
  isBigScreenVar:boolean=false;

  /************* SETTINGS *************/
  // Par must be setted on server
  symbolLetterHidden='&#9729;';
  catChosen="rubedo";

  developMode: string = "production"; // can be "develop" or "production" or "stable" or "anonymousproduction"
  suffix: Object = { develop: "_dev", production: "_pr", stable:"_stable", anonymousproduction:"_pr"};
  serverPort: Object = { develop: "3334", production: "3338", stable:"3335", anonymousproduction: "3338"};
  
  numMaxGamesDisplayWalktroughtMsg=1;
  defaultAppVolume: number = 20; // 0 - 100

  /*This avoid splitting totally a book and slowing the game. It will be considered only element between current bookmark
  and this coefficent times the necessary blocks (which must be a good compromise to skip bad sentence eventually)*/
  /* ONLY word classic modes */ 
  numSentenceToGuessInOneRound:number=6;
  coefficentGoAheadOnCutBook=20; // put here 5 at least

  /* Shannon classical gamemode is a particular case of shannon hangman in which this value is one */
  numLetterGuessableSimul = {
    shannon: 1,
    shannon_reverse: 1,
    shannon_hangman: 20,
    shannon_hangman_reverse: 20,
  };
  // This number is half before and half after the current bookmark, that's why the *2. This avoid splitting totally a book and slowing the game.
  numLetterToConsiderInASingleGame:number = (200)*2;

  // ATTENTION!!! If this number is changed, must be also changed the number in getSingleGameForVersus
  // on server (bookmarkLetterInitial>=numCharacterPriorOrPosterior+5) in order for versus not to have problem with
  // prior in versus mode
  numCharacterPriorOrPosterior:number=100;

  emptyScore:number = 0;
  emptyLevel:number = 1;
  emptyNumberOfLogin:number = 0;

  emptySettingsCurrentGamemode:string = 'shannon';
  emptySettingsCurrentDifficulty:string = 'normal';
  emptySettingsCurrentLanguage:string = 'en';
  emptySettingsCurrentSoundEffectStatus:number = 1;
  emptySettingsCurrentMusicVolume:number = this.defaultAppVolume;
  emptySettingsCurrentCatChosen:string = "rubedo";

  // was easy: 2, normal: 4, hard: 6
  bonusScore={
    chunkFinished: 1000
  }

  functionsnumErrorAfterWhichThanosHit=3;
  percLetterToRemoveInThanosMode={
    easy: 0,
    normal: 0,
    hard: 0
  }

  /************* END SETTINGS *************/

  // Books will be displayed in home in this order
  // (This variable controls which book will be displayed in home and their order)
  booksPlayable = 
        [7,8,9,10,                                  //it
        3,2,4,5,11,12,13,14,15,16,17,18];                                   //en   
  
  // Books available in versus mode. NB: books available in versus MUST NOT
  // be available in normal mode and viceversa
  booksPlayableInVersus = 
      [6,                                          //it
      1];                                          //en  

  // Books available totally in the game. Used by the function storing in booksdata
  booksAvailable = 
      [7,6,8,9,10,                                 //it
      3,1,2,4,5,11,12,13,14,15,16,17,18];                                  //en  

  emptyCollectibles:any = {};

  emptyBooksinfo:any=[
    {
      book:1,
      skip:0,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon",
      numsnttotal:0,
      numchunktotal:212,
      indexlastcharacterinbook:17438
    },{
      book:2,
      skip:0,
      bookmark:0,
      bookmarkLetter:22415,
      currentIdChunkInBook:303,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon_reverse",
      numsnttotal:0,
      numchunktotal:304,
      indexlastcharacterinbook:22416
    },{
      book:3,
      skip:0,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon",
      numsnttotal:0,
      numchunktotal:143,
      indexlastcharacterinbook:11104
    },{
      book:4,
      skip:0,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon_hangman",
      numsnttotal:0,
      numchunktotal:401,
      indexlastcharacterinbook:34295
    },
    {
      book:5,
      skip:0,
      bookmark:0,
      bookmarkLetter:8461,
      currentIdChunkInBook:120,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon_hangman_reverse",
      numsnttotal:0,
      numchunktotal:121,
      indexlastcharacterinbook:8462
    },{
      book:6,
      skip:0,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"it",
      gamemode:"shannon",
      numsnttotal:0,
      numchunktotal:133,
      indexlastcharacterinbook:11359
    },
    {
      book:7,
      skip:0,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"it",
      gamemode:"shannon",
      numsnttotal:0,
      numchunktotal:151,
      indexlastcharacterinbook:11606
    },{
      book:8,
      skip:0,
      bookmark:0,
      bookmarkLetter:8976,
      currentIdChunkInBook:109,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"it",
      gamemode:"shannon_reverse",
      numsnttotal:0,
      numchunktotal:110,
      indexlastcharacterinbook:8977
    },
    {
      book:9,
      skip:0,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"it",
      gamemode:"shannon_hangman",
      numsnttotal:0,
      numchunktotal:491,
      indexlastcharacterinbook:48622
    },{
      book:10,
      skip:0,
      bookmark:0,
      bookmarkLetter:59468,
      currentIdChunkInBook:608,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"it",
      gamemode:"shannon_hangman_reverse",
      numsnttotal:0,
      numchunktotal:609,
      indexlastcharacterinbook:59469
    },
    {
      book:11,
      skip:0,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon",
      numsnttotal:0,
      numchunktotal:133,
      indexlastcharacterinbook:11591
    },{
      book:12,
      skip:0,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon",
      numsnttotal:0,
      numchunktotal:318,
      indexlastcharacterinbook:22999
    },{
      book:13,
      skip:0,
      bookmark:0,
      bookmarkLetter:4600,
      currentIdChunkInBook:61,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon_reverse",
      numsnttotal:0,
      numchunktotal:62,
      indexlastcharacterinbook:4601
    },{
      book:14,
      skip:0,
      bookmark:0,
      bookmarkLetter:18428,
      currentIdChunkInBook:209,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon_reverse",
      numsnttotal:0,
      numchunktotal:210,
      indexlastcharacterinbook:18429
    },{
      book:15,
      skip:0,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon_hangman",
      numsnttotal:0,
      numchunktotal:212,
      indexlastcharacterinbook:15026
    },{
      book:16,
      skip:0,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon_hangman",
      numsnttotal:0,
      numchunktotal:221,
      indexlastcharacterinbook:15981
    },{
      book:17,
      skip:0,
      bookmark:0,
      bookmarkLetter:14832,
      currentIdChunkInBook:181,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon_hangman_reverse",
      numsnttotal:0,
      numchunktotal:182,
      indexlastcharacterinbook:14833
    },{
      book:18,
      skip:0,
      bookmark:0,
      bookmarkLetter:40305,
      currentIdChunkInBook:560,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon_hangman_reverse",
      numsnttotal:0,
      numchunktotal:561,
      indexlastcharacterinbook:40306
    },{
      book:19,
      skip:30,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"it",
      gamemode:"shannon",
      numsnttotal:163,
      numchunktotal:0,
      indexlastcharacterinbook:11609
    },{
      book:20,
      skip:30,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon",
      numsnttotal:164,
      numchunktotal:0,
      indexlastcharacterinbook:11102
    },{
      book:21,
      skip:30,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"it",
      gamemode:"shannon",
      numsnttotal:423,
      numchunktotal:0,
      indexlastcharacterinbook:29447
    },
    {
      book:22,
      skip:30,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"en",
      gamemode:"shannon",
      numsnttotal:50,
      numchunktotal:0,
      indexlastcharacterinbook:2932
    },
    {
      book:23,
      skip:30,
      bookmark:0,
      bookmarkLetter:0,
      currentIdChunkInBook:0,
      currentTime:0,
      currentNumLettersGuessedInCurrentChunk:0,
      currentChunkScore:0,
      language:"it",
      gamemode:"shannon_hangman",
      numsnttotal:104,
      numchunktotal:0,
      indexlastcharacterinbook:8072
    }
  ];

  constructor(public smartAudio: SmartAudio, public events: Events, private storage: Storage, public http: Http, public connectivityService: ConnectivityService, public translate: TranslateService, public platform: Platform, public sanitizer: DomSanitizer) {
    this.getCurrentBrowser();
    this.idCurrentBook=1;
    this.difficulty=this.emptySettingsCurrentDifficulty;  // normal, easy, hard
    this.gamemode=this.emptySettingsCurrentGamemode;   // classic, reverse, random, shannon
    this.gamemodeVersusActive=false;
    this.catChosen="rubedo";
    this.setDifficulty();
    this.setLanguage();
    this.setGameMode();
    this.changeShowSidemenuButtonTo(false);
    this.smartAudio.volume=this.defaultAppVolume; // use 100 after develop, values 0-100

    this.serverurl=this.getServerUrl();
  }

  getHomeUrl(){
    /*var url="";
    console.log("^^^^^^^ location: "+window.location.protocol+"//"+window.location.hostname);
    if (window.location.protocol!="" && window.location.hostname!="") {
      url+=window.location.protocol+"//"+window.location.hostname;
    }
    
    //console.log("^^^^^^^ port: "+window.location.port);
    //if (window.location.port!="") {
    //  url+=":"+window.location.port;
    //}
    
    console.log("^^^^^^^ url: "+url);
    if (url=="") {
      url="http://xtribe.eu";
    }
    console.log("^^^^^^^ url: "+url);*/
    
    return "http://xtribe.eu";
  }

  getServerUrl(){
    return this.getHomeUrl()+":"+this.serverPort[this.developMode]+"/api/rubedo"+this.suffix[this.developMode];
  }

  /* Possible values
      android	on a device running Android.
      cordova	on a device running Cordova.
      core	on a desktop device.
      ios	on a device running iOS.
      ipad	on an iPad device.
      iphone	on an iPhone device.
      mobile	on a mobile device.
      mobileweb	in a browser on a mobile device.
      phablet	on a phablet device.
      tablet	on a tablet device.
      windows	on a device running Windows

      Can contain more than a value, separated by commas
  */
  getCurrentDevice(){
    var stringDevice="";
    this.currentDevice=this.platform.platforms();
    for (let i = 0; i < this.currentDevice.length; i++) {
      stringDevice+=this.currentDevice[i]+"|"
    }
    this.currentDevice=stringDevice;
    return this.currentDevice;
  }

  isRunningOnMobile(){
    return this.isCurrentDevice('mobile');
  }

  isRunningOnIos(){
    return this.isCurrentDevice('ios');
  }

  isRunningOnDesktop(){
    return this.isCurrentDevice('core');
  }

  isInDevelopMode(){
    //return this.developMode!="production";
    return this.developMode=="develop";
  }

  isCurrentDevice(platform){
    if(this.platform.is(platform)){
      return true;
    }else{
      return false;
    }
  }

  getRandomGameBg(){
    this.numBg=this.getRandomIntBetween(1,6);
    return 'game_'+this.numBg+'_BgMusic';
  }

  initApp(){
    /* LOAD BG MUSICS */
    var tmpVol=this.smartAudio.getCurrentVolume();
    this.smartAudio.preloadComplex('app_BgMusic', 'assets/audio/bensound-buddy.mp3',tmpVol, 1, 0);

    this.smartAudio.preloadComplex('game_1_BgMusic', 'assets/audio/bensound-cute.mp3',tmpVol, 1, 0);
    this.smartAudio.preloadComplex('game_2_BgMusic', 'assets/audio/bensound-clearday.mp3',tmpVol, 1, 0);
    this.smartAudio.preloadComplex('game_3_BgMusic', 'assets/audio/bensound-jazzcomedy.mp3',tmpVol, 1, 0);
    this.smartAudio.preloadComplex('game_4_BgMusic', 'assets/audio/bensound-littleidea.mp3',tmpVol, 1, 0);
    this.smartAudio.preloadComplex('game_5_BgMusic', 'assets/audio/bensound-retrosoul.mp3',tmpVol, 1, 0);
    this.smartAudio.preloadComplex('game_6_BgMusic', 'assets/audio/bensound-ukulele.mp3',tmpVol, 1, 0);

    this.smartAudio.preloadComplex('game_youLost', 'assets/audio/bensound-psychedelic.mp3',tmpVol, 1, 0);
    this.smartAudio.preloadComplex('game_youWin', 'assets/audio/win.mp3',tmpVol, 1, 0);

    /* LOAD AUDIO EFFECTS */
    this.smartAudio.preloadSimple('cat_collar','assets/audio/cat-collar-jingle.mp3');
    this.smartAudio.preloadSimple('tick_tock','assets/audio/ticktock.mp3');
    this.smartAudio.preloadSimple('kitten_meow','assets/audio/kittenmeow.mp3');
    this.smartAudio.preloadSimple('sad_trombone','assets/audio/sad_trombone.mp3');
    this.smartAudio.preloadSimple('claps','assets/audio/claps.mp3');
  }

  normalizeWordForComparison(word){
    // Normalized get rid of capital lettere and acute accents (substitute with grave)
    var normalizedWord=word;

    normalizedWord = normalizedWord.toLowerCase();
    
    if(normalizedWord){
      //normalizedWord = normalizedWord.replace(/é/gi, "è");
      //normalizedWord = normalizedWord.replace(/ó/gi, "ò");
      normalizedWord = normalizedWord.replace(/á/gi, "à");
      normalizedWord = normalizedWord.replace(/í/gi, "ì");
      normalizedWord = normalizedWord.replace(/ú/gi, "ù");
    }
    return normalizedWord;
  }

  play(musicName){
    this.smartAudio.play(musicName);
  }

  startBgMusic(musicName){
    this.smartAudio.startBgMusic(musicName);
  }

  stopBgMusic(musicName){
    this.smartAudio.stopBgMusic(musicName);
  }

  currentTimestamp(){
    return Date.now();
  };

  deviceIsOnline(){
    return this.connectivityService.isOnline();
  }

  convertStringDateForViz(date){
    date = date.split(' ')[0];
    var dateISO = new Date(date).toISOString();
    return dateISO;
  }

  getDateTodayYYYY_MM_DD(){
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth()+1; //January is 0!
    var yyyy = today.getFullYear();

    var ddString;
    var mmString;
    var todayString;
    
    if(dd<10) {
      ddString = '0'+dd;
    }else{
      ddString = ''+dd;
    }
    
    if(mm<10) {
      mmString = '0'+mm;
    }else{
      mmString = ''+mm;
    }
    
    todayString = yyyy+'-'+mmString+'-'+ddString;
    return todayString;
  }


  getGameTimeAvailableAtCurrentDifficulty(){
    var timeAvailable=100;
    if(this.difficulty=="easy"){ timeAvailable=300; } // 300
    if(this.difficulty=="normal"){ timeAvailable=200; } //200
    if(this.difficulty=="hard"){ timeAvailable=100; } //100
    
    return timeAvailable;
  }

  changeShowSidemenuButtonTo(value){
    this.showSidemenuButton=value;
  }

  setSideMenuColorEnabled(state){
    let elem: HTMLElement = document.getElementById('sideMenuButton');
    if(elem){
      if(!state){
        elem.setAttribute("style", "background-color:#ccc;");
      }else{
        elem.setAttribute("style", "background-color:#ef3b3b;");
      }
    }
  }

  getRandomIntBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  removeDiacritics(str){
      var defaultDiacriticsRemovalMap = [
        {'base':'A', 'letters':/[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g},
        {'base':'AA','letters':/[\uA732]/g},
        {'base':'AE','letters':/[\u00C6\u01FC\u01E2]/g},
        {'base':'AO','letters':/[\uA734]/g},
        {'base':'AU','letters':/[\uA736]/g},
        {'base':'AV','letters':/[\uA738\uA73A]/g},
        {'base':'AY','letters':/[\uA73C]/g},
        {'base':'B', 'letters':/[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g},
        {'base':'C', 'letters':/[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g},
        {'base':'D', 'letters':/[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g},
        {'base':'DZ','letters':/[\u01F1\u01C4]/g},
        {'base':'Dz','letters':/[\u01F2\u01C5]/g},
        {'base':'E', 'letters':/[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g},
        {'base':'F', 'letters':/[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g},
        {'base':'G', 'letters':/[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g},
        {'base':'H', 'letters':/[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g},
        {'base':'I', 'letters':/[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g},
        {'base':'J', 'letters':/[\u004A\u24BF\uFF2A\u0134\u0248]/g},
        {'base':'K', 'letters':/[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g},
        {'base':'L', 'letters':/[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g},
        {'base':'LJ','letters':/[\u01C7]/g},
        {'base':'Lj','letters':/[\u01C8]/g},
        {'base':'M', 'letters':/[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g},
        {'base':'N', 'letters':/[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g},
        {'base':'NJ','letters':/[\u01CA]/g},
        {'base':'Nj','letters':/[\u01CB]/g},
        {'base':'O', 'letters':/[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g},
        {'base':'OI','letters':/[\u01A2]/g},
        {'base':'OO','letters':/[\uA74E]/g},
        {'base':'OU','letters':/[\u0222]/g},
        {'base':'P', 'letters':/[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g},
        {'base':'Q', 'letters':/[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g},
        {'base':'R', 'letters':/[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g},
        {'base':'S', 'letters':/[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g},
        {'base':'T', 'letters':/[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g},
        {'base':'TZ','letters':/[\uA728]/g},
        {'base':'U', 'letters':/[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g},
        {'base':'V', 'letters':/[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g},
        {'base':'VY','letters':/[\uA760]/g},
        {'base':'W', 'letters':/[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g},
        {'base':'X', 'letters':/[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g},
        {'base':'Y', 'letters':/[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g},
        {'base':'Z', 'letters':/[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g},
        {'base':'a', 'letters':/[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g},
        {'base':'aa','letters':/[\uA733]/g},
        {'base':'ae','letters':/[\u00E6\u01FD\u01E3]/g},
        {'base':'ao','letters':/[\uA735]/g},
        {'base':'au','letters':/[\uA737]/g},
        {'base':'av','letters':/[\uA739\uA73B]/g},
        {'base':'ay','letters':/[\uA73D]/g},
        {'base':'b', 'letters':/[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g},
        {'base':'c', 'letters':/[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g},
        {'base':'d', 'letters':/[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g},
        {'base':'dz','letters':/[\u01F3\u01C6]/g},
        {'base':'e', 'letters':/[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g},
        {'base':'f', 'letters':/[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g},
        {'base':'g', 'letters':/[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g},
        {'base':'h', 'letters':/[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g},
        {'base':'hv','letters':/[\u0195]/g},
        {'base':'i', 'letters':/[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g},
        {'base':'j', 'letters':/[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g},
        {'base':'k', 'letters':/[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g},
        {'base':'l', 'letters':/[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g},
        {'base':'lj','letters':/[\u01C9]/g},
        {'base':'m', 'letters':/[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g},
        {'base':'n', 'letters':/[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g},
        {'base':'nj','letters':/[\u01CC]/g},
        {'base':'o', 'letters':/[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g},
        {'base':'oi','letters':/[\u01A3]/g},
        {'base':'ou','letters':/[\u0223]/g},
        {'base':'oo','letters':/[\uA74F]/g},
        {'base':'p','letters':/[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g},
        {'base':'q','letters':/[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g},
        {'base':'r','letters':/[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g},
        {'base':'s','letters':/[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g},
        {'base':'t','letters':/[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g},
        {'base':'tz','letters':/[\uA729]/g},
        {'base':'u','letters':/[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g},
        {'base':'v','letters':/[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g},
        {'base':'vy','letters':/[\uA761]/g},
        {'base':'w','letters':/[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g},
        {'base':'x','letters':/[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g},
        {'base':'y','letters':/[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g},
        {'base':'z','letters':/[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g}
      ];
    
      for(var i=0; i<defaultDiacriticsRemovalMap.length; i++) {
        str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
      }
    
      return str;
    }

  splitInSentences(textblockToSplit){
    var textblockToSplitAfterReplace: string;
    /*
    Regular expression:
    - enclosed between / and /
    - after the second / we can have flags that can be 'g' Global search, 'i'	Case-insensitive search, 'm'	Multi-line search, 'u'	unicode; treat pattern as a sequence of unicode code points, 'y'	Perform a "sticky" search that matches starting at the current position in the target string. See sticky
    - ^ and $ match beginning and end of input
    - \ indicates that next character is special and not to be interpreted literally. For example, a 'b' without a preceding '\' generally matches lowercase 'b's wherever they occur. But a '\b' by itself doesn't match any character; it forms the special word boundary character. (which includes too few character separator to be useful to use here)
    - (x) matches 'x' and remembers the match
    - * matches the preceding expression 0 or more times
    - [xyz] Character set. This pattern type matches any one of the characters in the brackets, including escape sequences. Special characters like the dot(.) and asterisk (*) are not special inside a character set, so they don't need to be escaped.

    1) REGEXP splitting in sentences
    ([.?!»…]) = Capture either . or ? or ! or » or … as separators of sentences.
    \s* = Capture 0 or more whitespace characters following the previous token ([.?!]).
    (?=[A-Z]) = Optionally, the previous tokens only match if the next character is within the range A-Z (capital A to capital Z). Most English language sentences start with a capital letter.
    
    2) REPLACE
    "$1|" = We used one "capturing group" ([.?!]) and we capture one of those characters, and replace it with $1 (the match) plus |. So if we captured ? then the replacement would be ?|.
    
    3) SPLIT
    Finally, we split the pipes (|) and get our result.
    
    original regexp: /([.?!])\s*(?=[A-Z])/g
    */

    //TODO match any number of ? and !
    textblockToSplitAfterReplace=textblockToSplit.replace(/([.?!»…])»*\s*/g, "$1|");
    textblockToSplit=textblockToSplitAfterReplace.split("|");

    // Removing empty strings
    for (var i = 0; i < textblockToSplit.length; i++) { 
      if(textblockToSplit[i]==""){
        textblockToSplit.splice(i, 1);
      }
    }
    return textblockToSplit;
  }

  splitSentenceInWords(sentenceToSplit){
    var splitInWordsNoDiacritis: string[];
    var splitInWordsWithDiacritics: string[];
    var i:number;
    var counterBegin: number;
    var counterEnd: number;

    splitInWordsNoDiacritis=[];
    splitInWordsWithDiacritics=[];

    /*
      All'inizio avevo usato questa espressione regolare ma lasciava i punti finali etc attaccati alla parola: splitInWords=splitInSnt[i].split(/\b(?![\?\.\!])/); (x(?!y) matches 'x' only if 'x' is not followed by 'y'. This is called a negated lookahead.)
      Poi sono passata alla divisione classico word boundary ma non includeva le lettere accentate: splitInWords=splitInSnt[i].split(/\b/u);
      Alla fine siccome \b è uguale a (?<!\w)(?=\w)|(?<=\w)(?!\w)
      e \w è uguale a [A-Za-z0-9_]
      ho prodotto (?<![A-Za-z0-9À-ÿ])(?=[A-Za-z0-9À-ÿ])|(?<=[A-Za-z0-9À-ÿ])(?![A-Za-z0-9À-ÿ])
      che separa le parole considerando nella parola anche i caratteri accentati
      ma javascript non supporta ?> e ?< che sono i positive e negative lookbehind e quindi ho optato
    */

    splitInWordsNoDiacritis=this.removeDiacritics(sentenceToSplit).split(/\b/g);

    counterBegin=0;
    counterEnd=0;

    for (i = 0; i < splitInWordsNoDiacritis.length; i++) {
      counterEnd=splitInWordsNoDiacritis[i].length+counterBegin;
      splitInWordsWithDiacritics[i]=sentenceToSplit.substring(counterBegin, counterEnd);
      counterBegin=counterEnd;
    }
    return splitInWordsWithDiacritics;
  }

  isProperGuessableWord(splitInWords, word: string, position: number,storeOnServer: boolean){
    /* rejects
      - string that are not words (symbols, spaces, etc...)
      - names (words starting with a capital letter, but not if it is the first word) 
        It does not work for names as first words! 
        (how to distinguish a name if not by the capital letter? 
          Any word at the beginning of the sentence start with a capital letter)
      - articles for different language 
        ITA: di, a, da, in, con, su, per, tra, fra, il	lo	l'	la	i	gli	le
        ENG: the, a, an

      NB: To match all capital letters from your initial range, you may use [A-ZÀ-ÖØ-Þ] character class. 
      To match all lowercase letters, [a-zß-öø-ÿ]. 
      Note that × and ÷ are not letters, I removed them from these classes.

      	
    Add (?:\s+\w+)* to match multiple arbitrary words, or perhaps ( [a-z][A-Za-z]+)* to match multiple words 
    which all begin with lowercase. 
    */
    if(!word){
      console.log("ERROR: word undefined"+word);
      return false;
    }

    // ATTENZIONE: qui le parole vanno messe tutte MINUSCOLE
    var forbiddenWords = 
        [ "di", "a" , "da", "in", "con", "su", "per", "un", "tra", "fra", "il", "lo", "la", "i", "gli", "le", 
          "si", "ci", "mi", "ti", "ma", "ne", "si",
          "l", "dell", "all", "dall", "nell", "sull", "d", "c", "m",
          "the", "a", "an", "e", "and", "at",
          "adele", "ariela", "shiniga", "armand", "betta", "edoardo", "vanessa", "cattleya", "olmashi", "pinuccia",
          "edward", "osaki", "beth", "betta", "olimpia", "lucilla", "gattara", "aldo", "giulia", "volorapace", "trolley",
          "nina", "diane", "Gideon", "Limes",
          "oh", "ih", "ah", "eh", "uh",
          "reginotta", "reuccio", 
          "grundelwald", "tiburzio", "interlaken", "augusto", "fronier", "inghilterra", 
          "allegranza", "canarie", "josé ", "faja", "ex", "alcade", "insolatori", "marina", "lanzarote", 
          "carvalho", "souza", "america", "sud", "oceano", "rio", 
          "janeiro", "luglio", "calver", 
          "americans", "cadice", "europa", "atlantico", "meridionale", "pacifico", "chilì", "cina", 
          "condor", "indomalese", "calcutta", "harvey", "mexico", "irene", "rubens", "dollars", "dollar", 
          "dollaro", "dollari", "pandora", "mexico", "aztecs", "mayans", "cortez", "mexicans", "husky", "quatomec", 
          "spaniards", "montezuma", "juan", "tropics", "india", "man-god", "woman-god", "locust", 
          "southampton", "quogue", "harlow", "dr", "rolls", "royce", "christmas", "december", "shinnecock", "egypt", 
          "chiffon", "chiffons", "cabalistic", "godhead", "dunes",
          "portoghese", "portoghesi", "portogallo",
          "spagnolo", "spagnoli", "spagnola", "spagnole", "spagna",
          "africano", "africani",  "africana", "africane", "africa",
          "francese", "francesi", "francia",
          "americano", "americani", "americana", "americane", "america", "americhe",
          "indiano", "indiani", "indiana", "indiane", "india", "indie",
          "brasiliano", "brasiliani", "brasiliana", "brasiliane", "brasile",
          "isolano", "isolani", "isolana", "isolane",
          "vera somers","hoyt ","youngstown ","ohio","roman","romans","carthaginian","galleys","sesterces",
          "sesterce","duillius","consulship","quadricentuses","praetor","sicily","carthage","italy","scipios",
          "scipio","scip","toga","acta","diurna","woodbine","caius","farragut","nelson","calliopes","tiber",
          "alba","longa","centennial","cothurni","teddy","buttinsius","flutensius","smokius","torchius",
          "rome","latin","pop","weasel","erit tempus calidum in urbe antiqua hac nocte","capitoline","appian",
          "nb","rsvp","vlute","gaul",
          "lewis","swahili","bwana","balaka","lete","chakula ","maramoja","artesian","kiboko","gwendolin",
          "heine","dutchman","german","hohenzollern","baganda","chakula","lete","johnny","njugu",
          "englishmen","englishman","reuter","kimin","goodwood","china","serbia","austrian","irabanga",
          "portuguese","indian","dukkas","european","mccann","browning","downing","england",
          "sultani","bobby","calthrop","germany","france","russia","belgium","liege","hobart",
          "hardy","namur","marne","harding","pounds","pound","edward ","franks","laburnum","scotsburg",
          "terrace","parliament","gilt ","edged ","investment","spenlow","jorkins","roué","euston",
          "london","chimmons","lyceum","shakespeare","frenchwoman","arlingford","peter","embankment",
          "liberator","monson","irish","gladstone","leamington","english","somersets","putney","peckham",
          "charles","feudalism","antoine","pierre","michel","mauvais","sorcier","godfrey",
          "comte","henri","robert","louis","henris","roberts","antoines","armands","gothic",
          "khemiao","simon","elric","paracelso","albedo","nigredo","rubedo","paracelsus","teak"
        ];
    var containsforbiddenWords;
    var wordToCheckForForbiddenWords;
    var countCharacterInSnt=-1;
    var wordWhichTheCharBelongs="";

    if(!this.isGameModeShannon() || storeOnServer){
      wordToCheckForForbiddenWords=word;
    }else{
      // This find the word the current character belongs to and discard the character if it is part of
      // a forbidden word
      for (var i = 0; i < splitInWords.length; i++) { 
        countCharacterInSnt=countCharacterInSnt+splitInWords[i].length;
        if(countCharacterInSnt>=position){
          wordWhichTheCharBelongs=splitInWords[i];
          break;
        }
      } 
      wordToCheckForForbiddenWords=wordWhichTheCharBelongs;
    }

    // Disabled Forbidden word control for Shannon Mode
    if(!this.isGameModeShannon() || storeOnServer){
      containsforbiddenWords = (forbiddenWords.indexOf(wordToCheckForForbiddenWords.trim().toLowerCase()) > -1);
      
      if(containsforbiddenWords){
        return false;
      }
    }
    
    if(this.containsOnlyCharacter(word)){
      return true;
    }else{
      return false;
    }
  }

  containsOnlyCharacter(word){
    //if(position==0){
    var regexp=/[A-Za-zÀ-ÖØ-öø-Ÿ]+/; 
    //}else{
    //  regexp=/^[a-zß-öø-ÿœš][A-Za-zÀ-ÖØ-öø-Ÿ]*$/; // no word with capital letter at the beginning of the sentence
    //}
    
    if(word.match(regexp)){
      return true;
    }else{
      return false;
    }
  }

  indexExistInArray(index, array){   
    if(index>=0 && index<array.length){
      return true;
    }else{
      return false;
    }
  }

  nextIndexCircularArray(index, array){
    if(index+1<array.length){
      return index+1;
    }else{
      return 0;
    }
  }

  normalizeBookTextForShannonMode(splitInSnt){
    return splitInSnt.replace(/\r?\n|\r/g, ' ');
  }

  getArrayTextblocks(splitInSnt, bookmark, bookmarkLetter, idCurrentBook, storeOnServer, currentChunkStart, currentChunkEnd){
    var textblocks=[];
    var numBlocks=0; // Sentences number
    var maxIndexInWordsArray: number;
    var tmpSnt:string;
    var splitInWords: string[];
    var i:number;
    var j:number;
    var beginTaking:number;
    var endTaking:number;
    
    var bookmarkTextblock: string;
    var wholeTextblock: string;
    var slicedTextblock: string;
    var wholeTextblockLength: number;
    var sntBeginning: string[];
    var sntWordToGuess: string[];
    var sntEnding: string[];
    var skipThisBlock: number;

    var indexGuessWord: number;
    var indexFound: boolean;

    i=0;
    j=0;
    indexFound=false;
    splitInWords=[];
    sntBeginning=[];
    sntWordToGuess=[];
    sntEnding=[];

    var startingIndexForSearchWord: number;

    // For every sentence
    if(this.isGameModeShannon()){
      wholeTextblock=this.normalizeBookTextForShannonMode(splitInSnt); // remove enter and add a white space instead
      wholeTextblockLength=wholeTextblock.length;
      
      // Respect the restiction of number of text showed, no matter what
      beginTaking=Math.max(this.numCharacterPriorOrPosterior, Math.floor(this.numLetterToConsiderInASingleGame/2));
      if (beginTaking>=(bookmarkLetter)) {
        // Beginning of the book
        beginTaking=0;
      }else{
        beginTaking= bookmarkLetter - beginTaking;
      }
      if (this.isGameModeShannonReverse()) {
        beginTaking=currentChunkStart; 
      }
      
      endTaking=(bookmarkLetter-1)+Math.floor(this.numLetterToConsiderInASingleGame/2);
      if (endTaking>=wholeTextblock.length || endTaking<0) {
        // End of the book
        endTaking=wholeTextblock.length;
      }
      
      if (!this.isGameModeShannonReverse()) {
        endTaking=currentChunkEnd; 
      }
      
      console.log("beginTaking: "+beginTaking+" endTaking: "+endTaking);
      slicedTextblock=wholeTextblock.slice(beginTaking, endTaking+1);
      textblocks[0]={ 
        idBook: idCurrentBook,
        beginSlicedTexblock: beginTaking,
        endSlicedTexblock: endTaking,
        slicedTextblock: slicedTextblock,
        wholeTextblockLength: wholeTextblockLength
      }; 
    }else{
      numBlocks=splitInSnt.length;
      for (i = 0; i < numBlocks; i++) { 
        skipThisBlock=0;
        maxIndexInWordsArray=0;

        /* --------- GAMEMODE CLASSIC, REVERSE and RANDOM --------- */

        // If game mode is classic, reverse or random we use a number of sentences
        // (or if we need only to store on server the splitted blocks)
        if(!this.isGameModeShannon() || storeOnServer){
          splitInWords=this.splitSentenceInWords(splitInSnt[i]);
          maxIndexInWordsArray=splitInWords.length-1;
          
          tmpSnt=splitInSnt[i];

          if(maxIndexInWordsArray>0 ){ // at least two elements 0 and 1
            switch(this.gamemode) {
              case "reverse": // Mode REVERSE
                startingIndexForSearchWord=0;
                break;
              case "random":  // Mode RANDOM
                startingIndexForSearchWord=this.getRandomIntBetween(0,maxIndexInWordsArray);
                break;
              default:        // Mode CLASSIC
                startingIndexForSearchWord=maxIndexInWordsArray;
            }

            indexGuessWord=startingIndexForSearchWord;
            
            //console.log("indexGuessWord: "+indexGuessWord+" word:"+splitInWords[indexGuessWord]+"maxIndexInWordsArray: "+maxIndexInWordsArray+" guessable?"+this.isProperGuessableWord(splitInWords[indexGuessWord],indexGuessWord));

            /* If mode is:
                - classic: explores the array of sentence splitted in words from the last item to the first
                - reverse: explores the array of sentence splitted in words from the first item to the last
                - random: explores the array of sentence splitted in words from the item corresponding to 
                  a random chosen index as it was a circular (going from the item N to the end and then from the start to N)
            */

            indexFound=false;
            /*console.log("------------------------------------------------");
            console.log("maxIndexInWordsArray:"+JSON.stringify(maxIndexInWordsArray));*/
            for (j = 0; j <= maxIndexInWordsArray; j++) { 
              //console.log("splitInWords:"+JSON.stringify(splitInWords)+" j:"+j);
              if(!this.isProperGuessableWord(splitInWords,splitInWords[indexGuessWord],indexGuessWord,storeOnServer)){
                /*console.log("NOT PROPER");
                console.log("splitInWords:"+JSON.stringify(splitInWords));
                console.log("splitInWords[indexGuessWord]:"+JSON.stringify(splitInWords[indexGuessWord]));
                console.log("indexGuessWord:"+JSON.stringify(indexGuessWord));*/
                if(this.indexExistInArray(indexGuessWord,splitInWords)){
                  switch(this.gamemode) {
                    case "reverse": // Mode REVERSE
                      indexGuessWord=this.nextIndexCircularArray(indexGuessWord,splitInWords); //was indexGuessWord++;
                      break;
                    case "random":  // Mode RANDOM
                      indexGuessWord=this.nextIndexCircularArray(indexGuessWord,splitInWords);
                      break;
                    default:        // Mode CLASSIC
                      indexGuessWord--;
                  }
                  //console.log("----- index next:"+indexGuessWord);
                }else{
                  skipThisBlock=1;
                  //console.log("----- index skip:"+indexGuessWord);
                  break;
                }
              }else{
                //console.log("----- index found:"+indexGuessWord);
                indexFound=true;
                break;
              }
            }

            if(!this.indexExistInArray(indexGuessWord,splitInWords) || !indexFound){
              skipThisBlock=1;
            }

            sntWordToGuess[i] = splitInWords[indexGuessWord];

            if(!this.indexExistInArray(indexGuessWord-1,splitInWords) ){
              sntBeginning[i] = "";
            }else{
              sntBeginning[i] = splitInWords.slice(0,indexGuessWord).join(""); // slice doesn't included strictly the final element
            }

            if(!this.indexExistInArray(indexGuessWord+1,splitInWords)){
              sntBeginning[i] = "";
            }else{
              sntEnding[i] = splitInWords.slice(indexGuessWord+1).join("");    
            }

            bookmarkTextblock=bookmark+i;
            bookmarkLetter="0";
            wholeTextblock=splitInSnt[i];
          }else{
            console.log("ERROR: splitInWords array too short (#"+maxIndexInWordsArray+" elements) Sentence is:|"+splitInWords+"|"); 
            skipThisBlock=1;
            sntWordToGuess[i] = splitInWords[indexGuessWord];
            sntBeginning[i] = "";
            sntBeginning[i] = "";
            bookmarkTextblock=bookmark+i;
            bookmarkLetter="0";
            wholeTextblock=splitInSnt[bookmark+i];
          }
        }

        /* --------- END GAMEMODE CLASSIC, REVERSE and RANDOM --------- */

        // Debug parole scelte nei libri nelle varie modalità
        if(this.isInDevelopMode() && storeOnServer) {
          //this.debugStringWords=this.debugStringWords+" <br> "+"BEGINNING: "+sntBeginning[i];
          this.debugStringWords=this.debugStringWords+" <br> "+"WORD TO GUESS : "+sntWordToGuess[i];
          //this.debugStringWords=this.debugStringWords+" <br> "+"ENDING: "+sntEnding[i];
        }

        if (!this.isGameModeShannon() || storeOnServer) {
          textblocks[i]={ 
            idBook: idCurrentBook,
            bookmarkTextblock:bookmarkTextblock,
            bookmarkLetter:bookmarkLetter,
            wholeTextblock: wholeTextblock,
            splittedTextblock: JSON.stringify(splitInWords),
            beginning: sntBeginning[i],
            wordToGuess: sntWordToGuess[i],
            wordIndex: indexGuessWord,
            ending:sntEnding[i],
            skipThisBlock:skipThisBlock,
          };  
          /*  e.g:
          [{"idBook":20,"bookmarkTextblock":1,"bookmarkLetter":"0",
          "wholeTextblock":"He held his paws under his white chest and lazily stroked the table with his tail.",
          "splittedTextblock":"[\"He\",\" \",\"held\",\" \",\"his\",\" \",\"paws\",\" \",\"under\",\" \",\"his\",\" \",\"white\",\" \",\"chest\",\" \",\"and\",\" \",\"lazily\",\" \",\"stroked\",\" \",\"the\",\" \",\"table\",\" \",\"with\",\" \",\"his\",\" \",\"tail\",\".\"]",
          "beginning":"He held his paws under his white chest and lazily stroked the table with his ",
          "wordToGuess":"tail",
          "wordIndex":30,
          "ending":".",
          "skipThisBlock":0},
          {"idBook":20,"bookmarkTextblock":2,"bookmarkLetter":"0",
          "wholeTextblock":"The cat's whiskers, under the half closed eyes, vibrated from time to time in a hint of a purr.",
          "splittedTextblock":"[\"The\",\" \",\"cat\",\"'\",\"s\",\" \",\"whiskers\",\", \",\"under\",\" \",\"the\",\" \",\"half\",\" \",\"closed\",\" \",\"eyes\",\", \",\"vibrated\",\" \",\"from\",\" \",\"time\",\" \",\"to\",\" \",\"time\",\" \",\"in\",\" \",\"a\",\" \",\"hint\",\" \",\"of\",\" \",\"a\",\" \",\"purr\",\".\"]",
          "beginning":"The cat's whiskers, under the half closed eyes, vibrated from time to time in a hint of a ",
          "wordToGuess":"purr",
          "wordIndex":38,
          "ending":".",
          "skipThisBlock":0}]
          */
        }
      }
    }
    console.log("textblocks: "+JSON.stringify(textblocks));
    return textblocks;
  }

  getArrayTextblocksForStorinOnServer(splitInSnt, bookmark, bookmarkLetter, idCurrentBook){
    var textblocks=[];
    var i: number;

    textblocks=this.getArrayTextblocks(splitInSnt, bookmark, bookmarkLetter, idCurrentBook, true, 0, 0);
    
    for (i = 0; i < textblocks.length; i++) { 
      delete textblocks[i].beginning;
      delete textblocks[i].wordToGuess;
      delete textblocks[i].wordIndex;
      delete textblocks[i].ending;
      delete textblocks[i].bookmarkLetter;
    }

    return textblocks;
  }

  getArrayTextblocksForPlaying(splitInSnt, bookmark, bookmarkLetter, idCurrentBook,currentChunkStart,currentChunkEnd){
    var textblocks=[];
    var i: number;

    textblocks=this.getArrayTextblocks(splitInSnt, bookmark, bookmarkLetter, idCurrentBook, false, currentChunkStart, currentChunkEnd);
    for (i = 0; i < textblocks.length; i++) { 
      delete textblocks[i].splittedTextblock;
    }

    return textblocks;
  }

  storeBooksDataOnDatabaseOnServer(){
    var i: number;
    var splitInSntTotal;
    var wholeBook;
    i=1;
    //i=0; //for book test only activate this and remove for cycle

    // Here we use books available in order to put all the possible books in booksadata
    for (i = 0; i < this.booksAvailable.length; i++) { 
      this.http.get('assets/data/book_'+this.booksAvailable[i]+'.txt', {
        params: { idCurrentBookToStore: this.booksAvailable[i] }
        }).subscribe(data=>{
          let obj = data['_body'];
          let idCurrentBookToStore=this.getQueryString("idCurrentBookToStore",data['url']);
          if (!this.isGameModeShannon()) {
            splitInSntTotal=this.splitInSentences(obj);
            this.textblockForSingleSplicingForDB=this.getArrayTextblocksForStorinOnServer(splitInSntTotal,0,0,idCurrentBookToStore);
            if(this.textblockForSingleSplicingForDB.length > 0){ this.storeBooksDataOnServer(); } else { console.log("ERROR: textblock empty on storeBooksDataOnDatabaseOnServer!"); }
          }else{
            wholeBook=this.normalizeBookTextForShannonMode(obj);
            if(wholeBook.length > 0){ this.storeBooksDataOnServerShannon(idCurrentBookToStore,wholeBook); } else { console.log("ERROR: wholeBook empty on storeBooksDataOnDatabaseOnServerShannon!"); }
          }
      });
    }
  }

  /**
  * Get the value of a querystring
  * @param  {String} field The field to get the value of
  * @param  {String} url   The URL to get the value from (optional)
  * @return {String}       The field value
  */
  getQueryString = function ( field, url ) {
    var href = url ? url : window.location.href;
    var reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
    var string = reg.exec(href);
    return string ? string[1] : null;
  };

  storeBooksDataOnServer(){
    console.log("storeBooksDataOnServer");
    return new Promise((resolve) =>{
      if(!this.deviceIsOnline()){
        //this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = this.textblockForSingleSplicingForDB; 

      this.http.post(this.serverurl+"/storebooksdata", postParams, options)
        .subscribe(data => {
          //let obj = JSON.parse(data['_body']);
          resolve("storeBooksDataOnServerIsOk");
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          //this.setErrorMessage("storeBooksDataOnServer",error);
      });
    });
  }

  storeBooksDataOnServerShannon(idCurrentBookToStore,wholeTextblockShannon){
    console.log("storeBooksDataOnServerShannon");
    return new Promise((resolve) =>{
      if(!this.deviceIsOnline()){
        //this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = { 
        idBook: idCurrentBookToStore,
        wholeTextblock: wholeTextblockShannon
      }; 
  
      this.http.post(this.serverurl+"/storebooksdatashannon", postParams, options)
        .subscribe(data => {
          //let obj = JSON.parse(data['_body']);
          resolve("storeBooksDataOnServerShannonIsOk");
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          //this.setErrorMessage("storeBooksDataOnServerShannon",error);
      });
    });
  }

  hideWalkthrough(){
    document.getElementById("walkthrough-overlay").style.display="none";
    document.getElementById("walkthrough-overlay-with-buttons").style.display="none";
  }

  test(){
    document.getElementById("walkthrough-overlay").style.backgroundColor="red";
  }

  showWalkthroughWithMessage(message,catMood){
    this.translate.get(message).subscribe(value => { 
      this.walkthrough_text=this.sanitizer.bypassSecurityTrustHtml(value);
      this.walkthrough_catMood=catMood;
      document.getElementById("walkthrough-overlay").style.display="block";
    });
  }

  showWalkthroughWithMessageWithButtons(message,catMood){
    this.translate.get(message).subscribe(value => { 
      this.walkthrough_text=this.sanitizer.bypassSecurityTrustHtml(value);
      this.walkthrough_catMood=catMood;
      document.getElementById("walkthrough-overlay-with-buttons").style.display="block";
    });
  }
  
  setDifficulty(){
    this.storage.set('difficulty', this.difficulty);
  }

  getDifficulty(){
    this.storage.get('difficulty').then((difficulty) => {
      this.difficulty=difficulty;
    });
    return this.difficulty;
  }

  showMessage(toastCtrl, message) {
    let toast = toastCtrl.create({
      message: message,
      position: 'middle',
      cssClass: 'toastMessage',
      duration: 3000
    });
    toast.present();
  }

  showMessageTranslated(toastCtrl, message) {
    this.translate.get(message).subscribe(value => { 
      let toast = toastCtrl.create({
        message: value,
        position: 'middle',
        cssClass: 'toastMessage',
        duration: 3000
      });
      toast.present();
    });
  }

  isGameModeShannonStrictly(){
    return this.gamemode=="shannon";
  }

  isGameModeShannonReverseStrictly(){
    return this.gamemode=="shannon_reverse";
  }

  isGameModeShannonHangmanStrictly(){
    return this.gamemode=="shannon_hangman";
  }

  isGameModeShannonHangmanReverseStrictly(){
    return this.gamemode=="shannon_hangman_reverse";
  }

  isGameModeShannon(){
    return this.gamemode.indexOf("shannon") > -1;
  }

  isGameModeShannonReverse(){
    if (this.isGameModeShannon()) {
      return this.gamemode.indexOf("reverse") > -1;
    }
    return false;
  }

  isGameModeShannonHangman(){
    if (this.isGameModeShannon()) {
      return this.gamemode.indexOf("hangman") > -1;
    }
    return false;
  }

  isGameModeShannonHangmanReverse(){
    if (this.isGameModeShannonHangman()) {
      return this.gamemode.indexOf("hangman") > -1;
    }
    return false;
  }

  isGameModeVersus(){
    return this.gamemodeVersusActive==true;
  }

  changeLanguageTo(language){
    this.language=language;
    this.setLanguage();
  }

  setLanguage(){
    if(this.language=='it' || this.language=='en' ){
     this.translate.use(this.language)
     this.translate.setDefaultLang(this.language); 
    }
    // Reload menu language, see in app.component.ts
    this.events.publish('menu:langChanged');
    this.storage.set('language', this.language);
  }

  setGamemodeTo(gamemode){
    this.gamemode=gamemode
    this.setGameMode();
  }

  setGameMode(){
    this.storage.set('gamemode', this.gamemode);
  }

  getGameMode(){
    this.storage.get('gamemode').then((gamemode) => {
      this.gamemode=gamemode;
    });
    return this.gamemode;
  }

  getLanguage(){
    this.storage.get('language').then((language) => {
      this.language=language;
    });
    return this.language;
  }

  setSoundEffectIsActive(){
    this.storage.set('soundEffectIsActive', this.smartAudio.soundEffectIsActive);
  }

  getSoundEffectIsActive(){
    this.storage.get('soundEffectIsActive').then((soundEffectIsActive) => {
      this.smartAudio.soundEffectIsActive=soundEffectIsActive;
    });
    return this.smartAudio.soundEffectIsActive;
  }

  setVolume(){
    this.storage.set('volume', this.smartAudio.volume);
  }

  getVolume(){
    this.storage.get('volume').then((volume) => {
      this.smartAudio.volume=volume;
    });
    return this.smartAudio.volume;
  }

  setCatChosen(){
    this.storage.set('catChosen', this.catChosen);
  }

  getCatChosen(){
    this.storage.get('catChosen').then((catChosen) => {
      this.catChosen=catChosen;
    });
    return this.catChosen;
  }

  getIdCurrentBook(){
    return this.idCurrentBook;
  }

  setIdCurrentBook(idBook){
    this.idCurrentBook=idBook;
  }
  
  /**
   * Fisher–Yates shuffle algorithm:
   * Shuffles array in place.
   * @param {Array} a items An array containing the items.
   */
  fisherYatesShuffle(a) {
      var j, x, i;
      for (i = a.length - 1; i > 0; i--) {
          j = Math.floor(Math.random() * (i + 1));
          x = a[i];
          a[i] = a[j];
          a[j] = x;
      }
      return a;
  }

  array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

  isObjectEmpty(obj){
    for(var key in obj) {
      if(obj.hasOwnProperty(key))
          return false;
    }
    return true;
  }

  up_entro(arr) { 
    var counts = {}
    var norm = arr.length
    for (var i = 0; i < arr.length; i++) {
      var num = arr[i];
      counts[num] = counts[num] ? counts[num] + 1 : 1;
    }
    var res = 0.
    for (var key in counts) {
      res += counts[key]/norm * Math.log(counts[key]/norm)
    }
    return -res/Math.log(2);
  }
  
  
  down_entro(arr) { 
    var counts = {}
    var norm = arr.length
    var max_val = Math.max(...arr)
    for (var i = 1; i <= max_val +1; i++){
        counts[i] = 0
    }
    for (var i = 0; i < arr.length; i++) {
        counts[arr[i]]++;
    }
    var res = 0.
    for (var i = 1; i <= max_val; i++){
      res += i*(counts[i] - counts[i+1])* Math.log(i)/norm
    }
    return res/Math.log(2);
  }

  roundTwoDecimal(num){
    return Math.round(num * 100) / 100;
  }

  isLetterUppercase(letter){
    var regexp=/^[A-Z]$/; 
    return letter.match(regexp);
  }

  calculatePercentage(partial,total,typePercentage){
    var percentage=0;
    //console.log("BEF percentage: "+percentage+" type: "+typePercentage);
    if (total==0) { return 100; }
    percentage=Math.round((partial/total)*100); 
    if (percentage<0) { percentage=0; console.log("ERROR: '"+typePercentage+"' percentage under 0! Normalizing... Real percentage: "+percentage); }
    if (percentage>=101) { percentage=100; console.log("ERROR: '"+typePercentage+"' percentage over 100! Normalizing... Real percentage: "+percentage); }
    //console.log("AFT percentage: "+percentage);
    return percentage; 
  }

  isBigScreen(){
    if(this.platform.width()>1290 && this.platform.height()>730){
      this.isBigScreenVar=true;
      return true;
    }else{
      this.isBigScreenVar=false;
      return false;
    }
  }

  isVizMobile(){
    return this.platform.width()<=805;
  }

  setScaleForBigScreen() {
    if(this.isBigScreen()){
      // +50 just to have some margin
      this.scaleForBigScreen=Math.min((this.platform.height()/650),(this.platform.width()/850));
      //console.log("1 w: "+this.platform.width()+" h: "+this.platform.height()+" scaleForBigScreen:"+this.scaleForBigScreen);
      //document.getElementById('content-web-for-resize').style.transform='scale('+Math.min((this.platform.height()/650),(this.platform.width()/850))+')';
    }else{
      //console.log("2 w: "+this.platform.width()+" h: "+this.platform.height()+" scaleForBigScreen:"+this.scaleForBigScreen);
      this.scaleForBigScreen=1;
      //document.getElementById('content-web-for-resize').style.transform='scale(1)';
    }
  }

  isRunningOnBrowser(browsername){
    //console.log("----currentBrowser check for "+browsername+" on "+this.currentBrowser+" result: "+(this.currentBrowser==browsername));
    return this.currentBrowser==browsername;
  }

  // This is not precise, user agent is a mess, but is used only for the video now so who cares?
  // TODO test on device
  getCurrentBrowser(){
    if (navigator.userAgent) {
      //console.log("++++++navigator.userAgent: "+navigator.userAgent);
      if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 ) {
        this.currentBrowser='Opera';
      }
      else if(navigator.userAgent.indexOf("Chrome") != -1 ){
        this.currentBrowser='Chrome';
      }
      else if(navigator.userAgent.indexOf("Safari") != -1) {
        this.currentBrowser='Safari';
      }
      else if(navigator.userAgent.indexOf("Firefox") != -1) {
        this.currentBrowser='Firefox';
      }
      else if(navigator.userAgent.indexOf("MSIE") != -1 ) { //IF IE > 10
        this.currentBrowser='IE'; 
      }  
      else {
        this.currentBrowser='Unknown';
      }
      //console.log("++++++currentBrowser: "+this.currentBrowser);
    }else{
      this.currentBrowser='Unknown';
    }
  }

  generateGuidForThisSession() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    this.generatedGuidForThisSession=s4()+s4()+s4()+s4()+s4()+s4()+s4()+s4();
    console.log(this.generatedGuidForThisSession);
  }
}


// WEBPACK FOOTER //
// ./src/providers/functions.ts